/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SuprSendJwtTokenResponse } from './SuprSendJwtTokenResponse';
import {
    SuprSendJwtTokenResponseFromJSON,
    SuprSendJwtTokenResponseFromJSONTyped,
    SuprSendJwtTokenResponseToJSON,
    SuprSendJwtTokenResponseToJSONTyped,
} from './SuprSendJwtTokenResponse';

/**
 * 
 * @export
 * @interface SuprSendGenerateJwtToken200Response
 */
export interface SuprSendGenerateJwtToken200Response {
    /**
     * 
     */
    data?: SuprSendJwtTokenResponse;
}

/**
 * Check if a given object implements the SuprSendGenerateJwtToken200Response interface.
 */
export function instanceOfSuprSendGenerateJwtToken200Response(value: object): value is SuprSendGenerateJwtToken200Response {
    return true;
}

export function SuprSendGenerateJwtToken200ResponseFromJSON(json: any): SuprSendGenerateJwtToken200Response {
    return SuprSendGenerateJwtToken200ResponseFromJSONTyped(json, false);
}

export function SuprSendGenerateJwtToken200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuprSendGenerateJwtToken200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SuprSendJwtTokenResponseFromJSON(json['data']),
    };
}

export function SuprSendGenerateJwtToken200ResponseToJSON(json: any): SuprSendGenerateJwtToken200Response {
    return SuprSendGenerateJwtToken200ResponseToJSONTyped(json, false);
}

export function SuprSendGenerateJwtToken200ResponseToJSONTyped(value?: SuprSendGenerateJwtToken200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SuprSendJwtTokenResponseToJSON(value['data']),
    };
}

